import { UpdateProfileJobFocusRequest } from '@cbinsights/userintelservice/userintelservice';
import { request } from 'client/modules/common/utils/request';

type Props = Omit<Partial<UpdateProfileJobFocusRequest>, 'update_mask'> & {
  update_mask: { paths: string[] };
};

export const updateJobFocus = (req: Props): Promise<void> =>
  request({
    url: '/service/userintel/UpdateProfileJobFocus',
    body: req,
  }).then((r) => r.body);
